export const pluralVariety = function (number, nominative, plural, genitive) {

    return (number == 1)
        ? nominative
        :
        (
            ((number % 10 >= 2) && (number % 10 <= 4) && ((number % 100 < 12) || (number % 100 > 14)))
                ? plural
                : genitive
        );
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/utils/translations.js